export default class Disabled {
  toggle(element, isBoolean){
    element.prop('disabled', isBoolean);
  }
}
